// BL-177 Step 3 (audit, visible in the message's details): scheduled / edited / cancelled / waiting / sent / failed, who and when.
import React, { useState } from 'react';
import { formatScheduledWhen } from '../../lib/scheduledSend';

const VERBS = {
    scheduled: 'Scheduled', edited: 'Edited', cancelled: 'Cancelled', waiting: 'Held for the recipient\'s allowed hours', sent: 'Sent', failed: 'Failed',
};

export function describeScheduledEvent(event, staffNames = {}, timeZone = 'America/New_York') {
    const who = event.actor_id ? (staffNames[event.actor_id] || 'Staff') : 'IntelAgent';
    const verb = VERBS[event.event] || event.event;
    const detail = event.detail || {};
    const extra = event.event === 'edited' && Array.isArray(detail.changed) && detail.changed.length ? ` (${detail.changed.join(', ')})`
        : event.event === 'failed' && detail.reason ? `: ${detail.reason}`
            : event.event === 'cancelled' && detail.reason ? `: ${detail.reason}`
                : event.event === 'waiting' && detail.waitUntil ? ` until ${formatScheduledWhen(detail.waitUntil, timeZone)}`
                    : event.event === 'sent' && detail.sentNow ? ' (Send now)' : '';
    return `${verb}${extra} · ${who} · ${formatScheduledWhen(event.created_at, timeZone)}`;
}

export default function ScheduledHistory({ row, loadEvents, staffNames = {}, timeZone = 'America/New_York' }) {
    const [open, setOpen] = useState(false);
    const [events, setEvents] = useState(null);
    const [error, setError] = useState('');
    if (typeof loadEvents !== 'function' || !row?.id) return null;
    const toggle = async () => {
        const next = !open;
        setOpen(next);
        if (next) {
            try { setEvents(await loadEvents(row.id)); setError(''); } catch (failure) { setError(failure?.message || 'The history could not be loaded.'); }
        }
    };
    return (
        <div className="min-w-0 text-xs" data-scheduled-history="true">
            <button type="button" className="underline" aria-expanded={open} onClick={toggle}>{open ? 'Hide history' : 'History'}</button>
            {open && (
                <ul className="mt-1 list-disc pl-4" aria-label="Scheduled message history">
                    {error && <li role="alert">{error}</li>}
                    {events === null && !error && <li>Loading…</li>}
                    {(events || []).map((event) => <li key={event.id}>{describeScheduledEvent(event, staffNames, timeZone)}</li>)}
                    {events && events.length === 0 && <li>No history yet.</li>}
                </ul>
            )}
        </div>
    );
}
